import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

export const PromoStrip = ({ lines = [] }) => {
  const active = (lines || []).filter((l) => l.active && l.text);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (active.length <= 1) return;
    const iv = setInterval(() => setIdx((i) => (i + 1) % active.length), 4500);
    return () => clearInterval(iv);
  }, [active.length]);

  if (active.length === 0) return null;
  const current = active[idx % active.length];
  const Body = (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-x-3 gap-y-1 text-center">
      <span className="font-heading text-xl sm:text-2xl lg:text-3xl text-brand-navy leading-tight">
        {current.text}
      </span>
      {current.subtext && (
        <span className="text-brand-red font-black uppercase tracking-wide text-xs sm:text-sm">
          {current.subtext}
        </span>
      )}
      {current.link && <ArrowRight className="hidden sm:inline h-5 w-5 text-brand-red" />}
    </div>
  );

  return (
    <section className="bg-brand-yellow border-b-4 border-brand-navy" data-testid="promo-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5">
        <div className="flex items-center justify-center gap-2 mb-1.5">
          <Sparkles className="h-4 w-4 text-brand-navy" />
          <span className="text-[11px] font-black uppercase tracking-widest text-brand-navy/70">
            In stock in the warehouse now
          </span>
        </div>
        <div key={current.id} className="animate-fade-up" data-testid={`promo-line-${current.id}`}>
          {current.link ? (
            current.link.startsWith("/") ? (
              <Link to={current.link}>{Body}</Link>
            ) : (
              <a href={current.link} target="_blank" rel="noopener noreferrer">{Body}</a>
            )
          ) : (
            Body
          )}
        </div>
        {active.length > 1 && (
          <div className="flex items-center justify-center gap-1.5 mt-3">
            {active.map((l, i) => (
              <button
                key={l.id}
                onClick={() => setIdx(i)}
                aria-label={`Promo ${i + 1}`}
                data-testid={`promo-dot-${i}`}
                className={`h-2 rounded-full transition-all ${i === idx % active.length ? "w-6 bg-brand-navy" : "w-2 bg-brand-navy/30"}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
